import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-background py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex items-center space-x-2">
            <img 
              src="/assets/images/EchoNW_white_logo_long.png" 
              className="h-10"
              alt="Echo Network Logo" 
            />
          </div>
          
          <div className="flex items-center space-x-1 text-gray-300 hover:text-white transition-colors duration-300">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
            </svg>
            <a href="mailto:hello@echo-network.pp.ua" className="text-sm">hello@echo-network.pp.ua</a>
          </div>
          
          <div className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Echo Network. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;